export class OrderOperationClaimLine {
  static transform (obj) {
    let claimLine             = {}
    claimLine.id              = obj.id
    claimLine.details         = obj.attributes.details
    claimLine.orderOperationClaimServiceId = obj.attributes.order_operation_claim_service_id
    claimLine.wbsCodeId       = obj.attributes.wbs_code_id
    claimLine.quantity        = obj.attributes.quantity
    claimLine.reversal        = obj.attributes.reversal
    claimLine.notifyInvoiceAt = obj.attributes.notify_invoice_at
    claimLine.active          = obj.attributes.active
    claimLine.type            = obj.attributes.type
    return claimLine
  }
}



// WEBPACK FOOTER //
// ./src/helpers/orderOperationClaimLines/orderOperationClaimLine.transformer.js